import { toast } from "react-toastify";
import { call, put } from "redux-saga/effects";
import { api } from "../../Config/ApiInterface";
import { guestSearchFailure, guestSearchSuccess } from "../../Actions";

function* getSearchGuestDetailSaga(action) {
  try {
    const { name, email, phone, onOrderPage } = action.payload;
    const query = new URLSearchParams({
      ...(name && { name }),
      ...(email && { email }),
      ...(phone && { phone }),
    }).toString();
    let hotel_id=localStorage.getItem('hotel_id')

    const path = onOrderPage
      ? `/guest/today-guest?hotel_id=${hotel_id}&${query}`
      : `/guest/all-guest?hotel_id=${hotel_id}&${query}`;

    const response = yield call(api.post,path);
    if (response) {
      yield put(guestSearchSuccess(response.data));
    } else {
      yield put(
        guestSearchFailure(response.error || "Failed to fetch Amenities.")
      );
    }
    // toast.success(response.message);
  } catch (error) {
    yield put(guestSearchFailure(error));
    // toast.error("Failed to fetch Amenities.");
  }
}

export { getSearchGuestDetailSaga };
